import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImageAspectRatioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"image_aspect_ratio"}/>
}
